import React, { useState } from "react";
import { Button, Image, Col, Row, Modal, Table } from "react-bootstrap";
import Switch from "react-switch";
import moment from "moment";
import { NavLink } from "react-router-dom";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import SuperAdminDeleteOffer from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteOffer";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const ViewOfferDetailsOnline = ({
  onClickshowView,
  onClickCloseView,
  restaurantDetailFromOfferId,
  actionBy,
}) => {
  const [showLog, setShowLog] = useState(false);
  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [selectedTab, setSelectedTab] = useState("1");
  const [checkedBox, setCheckedBox] = useState(false);

  const handleChangeSwitch = (e) =>
    setCheckedBox({ checkedBox: !checkedBox.checkedBox });
  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [checked, setChecked] = useState(false);
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };

  return (
    <>
      <Modal
        show={onClickshowView}
        onHide={onClickCloseView}
        centered
        size="lg"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Offer Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="d-flex">
            <div className="enIMG75">
              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  <Image
                    src={
                      restaurantDetailFromOfferId &&
                      restaurantDetailFromOfferId.restaurant_id &&
                      restaurantDetailFromOfferId.restaurant_id.logo_url
                    }
                    alt={
                      restaurantDetailFromOfferId?.restaurant_id
                        ?.restaurant_name
                    }
                    title={
                      restaurantDetailFromOfferId?.restaurant_id
                        ?.restaurant_name
                    }
                    fluid
                    className="w-100 h-100"
                  />
                </SRLWrapper>
              </SimpleReactLightbox>
            </div>
            <div className="pl-3 row">
              <Col
                lg={10}
                xl={8}
                className="d-flex flex-column justify-content-between"
              >
                <div className="f24-500">
                  {restaurantDetailFromOfferId?.restaurant_id?.restaurant_name}
                </div>
                <div className="f14-400">
                  {
                    restaurantDetailFromOfferId?.restaurant_id
                      ?.restaurant_address
                  }
                </div>
              </Col>
            </div>
          </div>
          <hr />
          <div className="enTabs d-flex flex-wrap align-items-center mb-4 mb-2">
            <Button
              variant="link"
              onClick={(e) => handleTab("1")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === "1" ? "active" : ""
              }`}
            >
              General Information
            </Button>
            <Button
              variant="link"
              onClick={(e) => handleTab("2")}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === "2" ? "active" : ""
              }`}
            >
              Offer Settings
            </Button>
          </div>
          <div className="enGrayBorderBox">
            <Row className="px-4">
              <Col lg={7} md={12}>
                <Row>
                  <Col lg={8} md={6} className="py-3">
                    <div className="f12-500 pb-3">My Offers</div>
                    <div className="d-flex align-items-center">
                      <div className="text-center d-flex flex-column align-items-center">
                        <div className="enIMG62">
                          <SimpleReactLightbox>
                            <SRLWrapper options={options}>
                              <Image
                                src={
                                  restaurantDetailFromOfferId &&
                                  restaurantDetailFromOfferId.photos &&
                                  restaurantDetailFromOfferId.photos[0]
                                }
                                alt="View"
                                title="View"
                                fluid
                                className="w-100 h-100"
                              />
                            </SRLWrapper>
                          </SimpleReactLightbox>
                        </div>
                        <div className="enSuccessLBL mt-2">Online</div>
                      </div>
                      <div className="pl-3">
                        <div className="f14-500">
                          {restaurantDetailFromOfferId?.name}
                        </div>
                        <div className="f12-400">
                          {restaurantDetailFromOfferId?.description}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} md={6} className="py-3">
                    <div className="f12-500 pb-3">Start -End Date</div>
                    <div className="f12-500">
                      {moment(restaurantDetailFromOfferId?.start_date).format(
                        "Do MMM YY"
                      )}
                    </div>
                    <div className="f12-500 pl-4 py-1">to</div>
                    <div className="f12-500 text-red">
                      {moment(restaurantDetailFromOfferId?.end_date).format(
                        "Do MMM YY"
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={5} md={12}>
                <Row>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">Discount Type</div>
                    <div className="f12-500">
                      {restaurantDetailFromOfferId?.isOnline
                        ? restaurantDetailFromOfferId?.isPercentage
                          ? "Percentage"
                          : "Fixed Amount"
                        : "_"}
                    </div>
                  </Col>
                  <Col md={6} className="py-3">
                    <div className="f12-500 pb-3">Min Discount</div>
                    <div className="f12-500">
                      {restaurantDetailFromOfferId?.isOnline
                        ? restaurantDetailFromOfferId?.isPercentage
                          ? restaurantDetailFromOfferId?.discount
                          : "-"
                        : "-"}
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col md={12}>
                <hr />
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Status</div>
                <div className="d-flex align-items-center">
                  <div className="f12-400 mr-2">
                    {restaurantDetailFromOfferId?.active
                      ? "Active"
                      : "Inactive"}
                  </div>
                  <Switch
                    onChange={() => {}}
                    checked={restaurantDetailFromOfferId?.active}
                    offColor="#EEEEEE"
                    onColor="#EEEEEE"
                    offHandleColor="#212121"
                    onHandleColor="#59F832"
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={15}
                    width={41}
                    boxShadow="-2px 0px 5px #0000003B"
                    activeBoxShadow="-2px 0px 5px #0000003B"
                    id="material-switch"
                    disabled={actionBy === "viewSuperAdmin" ? true : false}
                  />
                </div>
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Primary</div>
                <div className="d-flex align-items-center">
                  <div
                    className={`${
                      restaurantDetailFromOfferId?.mark_as_primary
                        ? "f12-400 mr-2"
                        : "f12-500 mr-2"
                    }`}
                  >
                    No
                  </div>
                  <Switch
                    onChange={() => {}}
                    checked={restaurantDetailFromOfferId?.mark_as_primary}
                    offColor="#EEEEEE"
                    onColor="#EEEEEE"
                    offHandleColor="#212121"
                    onHandleColor="#59F832"
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={15}
                    width={41}
                    boxShadow="-2px 0px 5px #0000003B"
                    activeBoxShadow="-2px 0px 5px #0000003B"
                    id="material-switch"
                    disabled={actionBy === "viewSuperAdmin" ? true : false}
                  />
                  <div
                    className={`${
                      restaurantDetailFromOfferId?.mark_as_primary
                        ? "f12-500 ml-2"
                        : "f12-400 ml-2"
                    }`}
                  >
                    Yes
                  </div>
                </div>
              </Col>
              <Col lg={2} md={4} className="py-3">
                <div className="f12-500 pb-3">Views</div>
                <div className="f14-400">
                  {restaurantDetailFromOfferId?.offerViews}
                </div>
              </Col>
              <Col lg={2} md={4} className="py-3">
                <div className="f12-500 pb-3">Used</div>
                <div className="f14-400">
                  {restaurantDetailFromOfferId?.offerUsed}
                </div>
              </Col>
              <Col lg={2} md={4} className="py-3">
                <div className="f12-500 pb-3">Coupon Code</div>
                <div className="f14-400">
                  {restaurantDetailFromOfferId?.coupon_code}
                </div>
              </Col>
              <Col md={12}>
                <hr />
              </Col>
              <Col lg={3} md={6} className="py-3 d-flex">
                {/* <NavLink
                  to={`/superadminoffers/edit-online-offer/${
                    restaurantDetailFromOfferId &&
                    restaurantDetailFromOfferId._id
                  }`}
                  className="enIconBtn mr-3"
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/pencil.svg")}
                    alt="Edit"
                    title="Edit"
                    fluid
                  />
                </NavLink> */}
                <SuperAdminDeleteOffer
                  offerId={
                    restaurantDetailFromOfferId &&
                    restaurantDetailFromOfferId._id
                  }
                />
              </Col>
              <Col lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Coupon Code Usage Limit</div>
                <div className="f14-400">
                  {restaurantDetailFromOfferId?.maximum_usage_limit}
                </div>
              </Col>
            </Row>
          </div>

          {selectedTab === "1" && (
            <React.Fragment>
              <div className="pt-4 f12-400 opacity5">Offer Name</div>
              <div className="d-flex align-items-center pt-2">
                <div className="f16-500">
                  {restaurantDetailFromOfferId?.name}
                </div>
                <div className="enSuccessLBL ml-2">Online</div>
              </div>
              <div className="pt-4 f12-400 opacity5">Description</div>
              <div className="pt-2 f12-400">
                {restaurantDetailFromOfferId?.description}
              </div>
              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Start Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../../assets/images/UserManagement/calendar.svg")}
                      alt="View"
                      title="View"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f16-700">
                      {moment(restaurantDetailFromOfferId?.start_date).format(
                        "DD/MM/YYYY"
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Start Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-700">
                      {moment(restaurantDetailFromOfferId?.start_date).format(
                        "hh:mm A"
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">End Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../../assets/images/UserManagement/calendar.svg")}
                      alt="View"
                      title="View"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f16-700">
                      {moment(restaurantDetailFromOfferId?.end_date).format(
                        "DD/MM/YYYY"
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">End Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-700">
                      {moment(restaurantDetailFromOfferId?.end_date).format(
                        "hh:mm A"
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">Coupon Code</div>
                  <div className="f16-700">
                    {restaurantDetailFromOfferId?.coupon_code}
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">
                    Maximum Usage Limit
                  </div>
                  <div className="f16-700">
                    {restaurantDetailFromOfferId?.maximum_usage_limit}
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">Status</div>
                  <div className="d-flex align-items-center">
                    <div className="f14-500 mr-2">
                      {restaurantDetailFromOfferId?.active
                        ? "Active"
                        : "Inactive"}
                    </div>
                    <Switch
                      onChange={() => {}}
                      checked={restaurantDetailFromOfferId?.active}
                      offColor="#EEEEEE"
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={24}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={15}
                      width={41}
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      id="material-switch"
                    />
                  </div>
                </Col>
              </Row>
              <hr />
              <div className="pb-4">
                <div className="pb-2 f12-400 opacity5">Offers Photo</div>
                <div className="d-flex align-items-center justify-content-between flexWrap enIMG105">
                  {restaurantDetailFromOfferId?.photo_thumbnails &&
                    restaurantDetailFromOfferId?.photo_thumbnails.map(
                      (item, index) => {
                        return (
                          <React.Fragment key={index}>
                            <SimpleReactLightbox>
                              <SRLWrapper options={options}>
                                <Image
                                  src={item}
                                  alt="Offer Picture"
                                  title="Offer Picture"
                                  fluid
                                  className="w-100 h-100 img-fluid img-thumbnail"
                                />
                              </SRLWrapper>
                            </SimpleReactLightbox>
                          </React.Fragment>
                        );
                      }
                    )}
                </div>
                {/* <div className="pt-2 f12-400">
                  (You can upload only 1 pic per offer 700 x 420 pixels)
                </div> */}
              </div>
              <div className="pb-4">
                <div className="pb-2 f12-400 opacity5">Offer Video</div>
                <div className="enIMG105">
                  {restaurantDetailFromOfferId?.offerVideo === "" ? (
                    <p className="text-red f14-500">Video Not Available</p>
                  ) : restaurantDetailFromOfferId?.offerVideo !== undefined &&
                    restaurantDetailFromOfferId?.offerVideo !== null ? (
                    <div className="">
                      <video
                        width="100%"
                        height="100%"
                        controls
                        src={restaurantDetailFromOfferId?.offerVideo}
                        type="video/mp4"
                      />
                    </div>
                  ) : null}
                </div>
                {/* <div className="pt-2 f12-400">
                  (You can upload only 1 pic per offer 700 x 420 pixels)
                </div> */}
              </div>
              <div className="pb-4">
                <div className="f12-400 opacity5">Terms and Conditions</div>
                <div className="pt-2 f12-400">
                  {restaurantDetailFromOfferId?.terms_and_condition}
                </div>
              </div>
              <div className="pb-4">
                <div className="f12-400 opacity5">Refund & Cancellation</div>
                <div className="pt-2 f12-400">
                  {restaurantDetailFromOfferId?.refund_and_cancellation}
                </div>
              </div>
            </React.Fragment>
          )}
          {selectedTab === "2" && (
            <React.Fragment>
              <Row className>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-400 opacity5 pb-3">
                    Coupon Discount Type
                  </div>
                  <div className="f16-500">
                    {restaurantDetailFromOfferId?.isOnline
                      ? restaurantDetailFromOfferId?.isPercentage
                        ? "Percentage"
                        : "Fixed Amount"
                      : "_"}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-400 opacity5 pb-3">Coupon Discount</div>
                  <div className="f16-500">
                    {restaurantDetailFromOfferId?.isOnline
                      ? restaurantDetailFromOfferId?.isPercentage
                        ? restaurantDetailFromOfferId?.discount
                        : "-"
                      : "-"}
                  </div>
                </Col>
                <Col lg={6} md={12} className="py-3">
                  <div className="f12-400 opacity5 pb-3">
                    Applicable To Services
                  </div>
                  <div className="d-flex align-items-center f16-500">
                    {restaurantDetailFromOfferId?.service_type.length <= 0
                      ? "-"
                      : restaurantDetailFromOfferId?.service_type.map(
                          (item, index) => {
                            if (index === 0) {
                              return item;
                            } else if (item) {
                              return ", " + item;
                            }
                          }
                        )}
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          <hr />
          <div>
            <Button
              variant="link"
              onClick={handleShowMoreDetail}
              className="f18-700 px-0 pb-3 text-dark"
            >
              View more details{" "}
              <Image
                src={require("../../../../assets/images/UserManagement/up-arrow.svg")}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                className={`ml-2 ${
                  !showMoreDetail.showMoreDetail ? "en180deg" : ""
                }`}
              />
            </Button>
          </div>
          {showMoreDetail.showMoreDetail && (
            <div className="enGrayBorderBox">
              <Row className="px-4">
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Phone Number</div>
                  <div className="f14-400">
                    {restaurantDetailFromOfferId?.restaurant_id
                      ?.contact_detail &&
                    restaurantDetailFromOfferId?.restaurant_id?.contact_detail
                      .length <= 0
                      ? "-"
                      : restaurantDetailFromOfferId?.restaurant_id?.contact_detail.map(
                          (item, index) => {
                            if (index === 0) {
                              return item.country_code + item.mobile_no;
                            } else if (item) {
                              return ", " + item.country_code + item.mobile_no;
                            }
                          }
                        )}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Offer ID</div>
                  <div className="f14-400">
                    #{restaurantDetailFromOfferId?._id}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Start Date / Time</div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.start_date).format(
                      "Do MMM YYYY"
                    )}
                  </div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.start_date).format(
                      "hh:mm A"
                    )}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">End Date / Time</div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.end_date).format(
                      "Do MMM YYYY"
                    )}
                  </div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.end_date).format(
                      "hh:mm A"
                    )}
                  </div>
                </Col>
                <Col md={12}>
                  <hr />
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Changed Date / Time</div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.updatedAt).format(
                      "Do MMM YYYY"
                    )}
                  </div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.updatedAt).format(
                      "hh:mm A"
                    )}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Created Date / Time</div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.createdAt).format(
                      "Do MMM YYYY"
                    )}
                  </div>
                  <div className="f14-400">
                    {moment(restaurantDetailFromOfferId?.createdAt).format(
                      "hh:mm A"
                    )}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Pont of Entry</div>
                  <div className="f14-400">Menually Added</div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Maximum Usage Limit</div>
                  <div className="f14-400">
                    {restaurantDetailFromOfferId?.maximum_usage_limit}
                  </div>
                </Col>
              </Row>
            </div>
          )}
          <hr />
          <Button
            variant="link"
            onClick={handleShowLog}
            className="f18-700 px-0 pb-3 text-dark"
          >
            View Audit Log{" "}
            <Image
              src={require("../../../../assets/images/UserManagement/up-arrow.svg")}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              className={`ml-2 ${!showLog.showLog ? "en180deg" : ""}`}
            />
          </Button>
          {showLog.showLog && (
            <div className="enGrayBorderBox">
              <Table responsive className="enAuditLogTBL">
                <tr>
                  <th className="">
                    <div className="f12-500">Date</div>
                  </th>
                  <th>
                    <div className="f12-500">Operation</div>
                  </th>
                  <th></th>
                </tr>
                {restaurantDetailFromOfferId?.auditLogs &&
                  restaurantDetailFromOfferId?.auditLogs.map((data, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td>
                            <div className="f12-500">
                              {moment(data.timestamp).format("Do MMMM, YYYY")}
                            </div>
                            <div className="f12-500">
                              {moment(data.timestamp).format("hh:mm A")}
                            </div>
                          </td>
                          <td>
                            <div className="f12-500">{data.message}</div>
                          </td>
                          <td>
                            <div className="f12-500">{data.initiator}</div>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewOfferDetailsOnline;
